import { render, staticRenderFns } from "./PageResultOverview.vue?vue&type=template&id=e5a71030&scoped=true&"
import script from "./PageResultOverview.vue?vue&type=script&lang=js&"
export * from "./PageResultOverview.vue?vue&type=script&lang=js&"
import style0 from "./PageResultOverview.vue?vue&type=style&index=0&id=e5a71030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a71030",
  null
  
)

export default component.exports